import axios from 'axios';
import {
    IPositionResponse,
    IUserObj,
    IUserWithToken,
    IMarketData,
    IDataForWithdrawal,
    IClosePositionParams,
    IAccountBalance,
    IDeposit,
    IWithdrawal,
    MarketHistoryItem,
    MarketHistoryTimeframe,
    IUsersStatsByDate, IVolumeByDate, ITransactionsByDate, IStatsSummary
} from './api.interfaces';

const apiClient = axios.create({
    baseURL: process.env.REACT_APP_MARKETS_DOMAIN
});

export const PositionStatusFilter = {
    OPEN: 'OPEN',
    CLOSED: 'CLOSED'
}
class ApiService {

    async positionsContractGet(): Promise<IPositionResponse[]> {
        const response = await apiClient.get<IPositionResponse[]>('/api/v1/positions/contract');
        return response.data;
    }

    async positionsGet(user: string, status: string): Promise<IPositionResponse[]> {
        const response = await apiClient.get<IPositionResponse[]>('/api/v1/positions', { params: { user, status } });
        return response.data;
    }

    async positionsPost(data: any): Promise<IPositionResponse> {
        const response = await apiClient.post<IPositionResponse>('/api/v1/positions', data);
        return response.data;
    }

    async positionsUpdatePost(data: any): Promise<IPositionResponse> {
        const response = await apiClient.post<IPositionResponse>('/api/v1/positions/update', data);
        return response.data;
    }

    async positionsClosePost(data: IClosePositionParams): Promise<IPositionResponse> {
        const response = await apiClient.post<IPositionResponse>('/api/v1/positions/close', data);
        return response.data;
    }

    async marketsGet(): Promise<IMarketData[]> {
        const response = await apiClient.get<IMarketData[]>('/api/v1/markets');
        return response.data;
    }

    async marketsHistoryGet(params: { baseAsset: string, quoteAsset: string; timeframe: MarketHistoryTimeframe, points?: number }): Promise<MarketHistoryItem[]> {
        const response = await apiClient.get<MarketHistoryItem[]>('/api/v1/markets/history', { params });
        return response.data;
    }

    async accountsDepositsGet(data: IUserObj): Promise<IDeposit[]> {
        const response = await apiClient.get<IDeposit[]>(`/api/v1/accounts/${data.user}/deposits`);
        return response.data;
    }

    async accountsBalancesGet(data: IUserObj): Promise<IAccountBalance[]> {
        const response = await apiClient.get<IAccountBalance[]>(`/api/v1/accounts/${data.user}/balances`);
        return response.data;
    }

    async accountsBalancesContractGet(data: IUserWithToken): Promise<IPositionResponse[]> {
        const response = await apiClient.get<IPositionResponse[]>(`/api/v1/accounts/${data.user}/balances/${data.token}/contract`);
        return response.data;
    }

    async accountsWithdrawalsPost(data: IDataForWithdrawal): Promise<IPositionResponse> {
        const response = await apiClient.post<IPositionResponse>('/api/v1/accounts/withdrawals', data);
        return response.data;
    }

    async accountsWithdrawalsGet(data: IUserObj): Promise<IWithdrawal[]> {
        const response = await apiClient.get<IWithdrawal[]>(`/api/v1/accounts/${data.user}/withdrawals`);
        return response.data;
    }

    async usersStatsGet(): Promise<IUsersStatsByDate[]> {
        const response = await apiClient.get<IUsersStatsByDate[]>('/api/v1/analytics/history/users');
        return response.data;
    }

    async volumeStatsGet(): Promise<IVolumeByDate[]> {
        const response = await apiClient.get<IVolumeByDate[]>('/api/v1/analytics/history/volume');
        return response.data;
    }

    async txsStatsGet(): Promise<ITransactionsByDate[]> {
        const response = await apiClient.get<ITransactionsByDate[]>('/api/v1/analytics/history/txs');
        return response.data;
    }

    async statsSummaryGet(): Promise<IStatsSummary> {
        const response = await apiClient.get<IStatsSummary>('/api/v1/analytics/history/summary');
        return response.data;

    }

    async stakingHistoryGet(userAddress: string): Promise<IAccountBalance[]> {
        const response = await apiClient.get<IAccountBalance[]>(`/api/v1/staking/${userAddress}/history`);
        return response.data;
    }

    async stakingEarnedGet(userAddress: string): Promise<{totalEarned: string}> {
        const response = await apiClient.get<{totalEarned: string}>(`/api/v1/staking/${userAddress}/earned`);
        return response.data;
    }
}
const apiService = new ApiService();

export default apiService;